import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import AssetAdvancedConfig from "components/core/asset/advanced-field-config";
import FullParagraphAdvancedFieldsConfig from "segments/desktop/core-components/full-paragraph/advanced-fields-config";
import AdvancedThemeConfig from "segments/core-configs/advanced-theme-config";

const {
  topicBottomMargin,
  buttonTopMargin,
  withDynamicParagraphSubtitle,
  withDynamicParagraphTitle,
  ...restOfAdvancedParagraphConfig
} = FullParagraphAdvancedFieldsConfig;

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    ...SharedAdvancedFieldsConfig,
    ...AdvancedThemeConfig,
    advancedAssetProps: {
      type: FIELD_TYPES.NESTED,
      label: "Advanced asset config",
      fields: AssetAdvancedConfig
    },
    progressbarColor: {
      type: FIELD_TYPES.COLOR_PICKER,
      label: "Progressbar color"
    },
    tabLabelHeight: {
      type: FIELD_TYPES.TEXT,
      label: "Tab label height (default 32px)"
    },
    transitionTime: {
      type: FIELD_TYPES.TEXT,
      label: "Transition time (ms) between slides - also set auto play"
    },
    tabContentGap: {
      type: FIELD_TYPES.TEXT,
      label: "Margin between testimonial and stats (default 40px)"
    },
    autoPlayWhenVisible: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Auto play when visible (make sure visibility sensor config is on)"
    },
    tabAdvancedConfig: {
      type: FIELD_TYPES.NESTED,
      label: "Tab advanced config",
      fields: {
        testimonialMaxWidth: {
          type: FIELD_TYPES.TEXT,
          label: "Testimonial max width"
        },
        advancedStatsConfig: {
          type: FIELD_TYPES.NESTED,
          fields: {
            ...restOfAdvancedParagraphConfig,
            lineMargin: { type: FIELD_TYPES.TEXT, label: "Margin between line and stats" }
          },
          label: "Advanced stats config"
        }
      }
    }
  }
};
